import React, { Component } from 'react'

import style from './style.css'

class ImageRatio extends Component {
    render() {
        return (
            <div className={style.scope} style={{backgroundImage: `url(${this.props.image})`}}>
                <div className={style[`ratio${this.props.ratio || '1x1'}`]}>
                    {/* <img src={this.props.image} alt='' /> */}
                </div>
            </div>
        )
    }
}

export default ImageRatio


// WEBPACK FOOTER //
// ./src/components/atoms/ImageRatio/index.js